/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import {
	Dialog,
	DialogContent,
	DialogTitle,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Button,
	DialogActions,
	Box,
	InputAdornment,
	Switch,
	FormControlLabel
} from "@material-ui/core";
import i18n from "i18next";
import React, { useEffect, useState } from "react";
import lod_ from "lodash";

/**
 * Cilumine specific: The dialog update the conversation's context with various options
 */
function CloseTransferCall({ code, actionObject, handleClose, handleSubmit }) {
	// Initialize config data
	const [statusList, setStatusList] = useState([]);

	// Initialize form data
	const [status, setStatus] = useState("");
	const [savedAmmountInEuro, setSavedAmmountInEuro] = useState(0);
	const [agentRetentionEffort, setAgentRetentionEffort] = useState(false);
	const [comment, setComment] = useState("");

	useEffect(() => {
		// Initialize config data
		if (!lod_.isNil(actionObject?.config?.status)) {
			setStatusList(actionObject.config.status);
			setStatus(actionObject.config.status[0].code);
		}
	}, []);

	/**
	 * Validate the dialog content form
	 * @returns
	 */
	const validateContentForm = () => {
		return (
			!lod_.isNil(status) &&
			!lod_.isNil(savedAmmountInEuro) &&
			!lod_.isNil(agentRetentionEffort) &&
			!lod_.isNil(comment)
		);
	};

	return (
		<div>
			<Dialog
				fullWidth={true}
				onClose={handleClose}
				maxWidth={"sm"}
				open
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					{i18n.t("TabAction.cilumine.Close.outgoingCall")}
				</DialogTitle>
				<DialogContent dividers>
					<Box style={{ display: "flex", flexDirection: "column", width: "100%" }}>
						{/* Status */}
						<Box pt={2}>
							<FormControl fullWidth variant="outlined">
								<InputLabel
									id="demo-simple-select-label"
									style={{ color: lod_.isEmpty(status) ? "red" : null }}
								>
									{i18n.t("TabAction.cilumine.Close.status")}
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={status}
									label={i18n.t("TabAction.cilumine.Close.status")}
									error={lod_.isNil(status)}
									onChange={e => setStatus(e.target.value)}
								>
									{statusList.map((item, index) => {
										return (
											<MenuItem key={index} value={item.code}>
												{item.label}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>

						{/* Saved ammount in euro */}
						<Box pt={2}>
							<TextField
								type="number"
								label={i18n.t("TabAction.cilumine.Close.saveAmmountInEuro")}
								variant="outlined"
								fullWidth
								value={savedAmmountInEuro}
								InputProps={{
									endAdornment: <InputAdornment position="start">€</InputAdornment>,
									inputProps: { step: "0.01" }
								}}
								onChange={e => setSavedAmmountInEuro(e.target.valueAsNumber)}
								error={lod_.isNil(savedAmmountInEuro)}
							/>
						</Box>

						{/* Agent retention effort */}
						<Box pt={2}>
							<FormControlLabel
								control={
									<Switch
										id="outlined-multiline-static"
										variant="outlined"
										value={agentRetentionEffort}
										onChange={e => {
											setAgentRetentionEffort(e.target.checked);
										}}
										error={lod_.isNil(agentRetentionEffort)}
									/>
								}
								label={i18n.t("TabAction.cilumine.Close.agentRetentionEffort")}
							/>
						</Box>

						{/* Comment */}
						<Box pt={2}>
							<TextField
								id="outlined-multiline-static"
								label={i18n.t("TabAction.cilumine.Close.comment")}
								multiline={true}
								rows={4}
								variant="outlined"
								fullWidth
								value={comment}
								onChange={e => setComment(e.target.value)}
								error={lod_.isNil(comment)}
							/>
						</Box>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} style={{ margin: "2%" }} color="secondary">
						{i18n.t("CD.cancel")}
					</Button>
					<Button
						onClick={() =>
							handleSubmit(
								{
									context: {
										callResult: {
											resultCode: status,
											savedAmount: savedAmmountInEuro,
											retentionEffort: agentRetentionEffort,
											comment: comment
										}
									}
								},
								code,
								actionObject
							)
						}
						style={{ margin: "2%" }}
						color="primary"
						disabled={!validateContentForm()}
					>
						{i18n.t("CD.validate")}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

export default CloseTransferCall;
